import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GoodsSwiper from './GoodsSwiper';
import axios from 'axios';
import { isMobile } from 'react-device-detect';
import { apiUrl, bannerImgUrl, goodsImgUrl } from '../../common/urls';
import '../../css/goods.css';
const NewReserveGoodsSwiper = ({ type }) => {
  const [list, setList] = useState([]);
  console.log(type);
  const getData = async () => {
    const result = await axios.get(apiUrl + '/api/v2/goods', {
      params: {
        page: 1,
        perPage: 48,
        sort: 'RECENT',
        filter: {
          stockFlag: type === 'stock' ? true : false,
          reserveFlag: type === 'reserve' ? true : false,
          saleFlag: true,
          titleFilter: [],
          brandFilter: [],
          categoryFilter: [],
          opendayFilter: [],
          reserveMonthFilter: [],
        },
      },
    });

    setList(result.data.list);
  };
  const _go = () => {
    if (type === 'reserve') {
      window.open('https://shop.aniplustv.com/reserve');
    } else {
      window.open('https://shop.aniplustv.com/stock');
    }
  };
  useEffect(() => {
    getData();
  }, []);

  // console.log(list);

  return (
    <div className={isMobile ? 'p_container1224' : 'p_container'}>
      <div className="m_new_product">
        <div
          className="product_title"
          style={{ cursor: 'pointer' }}
          onClick={_go}
        >
          <h2>
            {/* <Link href="/reserve"> */}
            <span>
              {type === 'reserve'
                ? `새로운 예약 상품`
                : '바로 배송 가능한 입고 상품'}
            </span>
            <span className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.32084 4.00004C8.61381 3.70723 9.08869 3.70736 9.3815 4.00033L17.3763 12L9.38048 19.9997C9.08767 20.2927 8.6128 20.2929 8.31982 20C8.02685 19.7072 8.02672 19.2324 8.31953 18.9394L15.2556 12L8.32054 5.0607C8.02773 4.76773 8.02786 4.29285 8.32084 4.00004Z"
                  fill="#333333"
                />
              </svg>
            </span>
            {/* </Link> */}
          </h2>
        </div>
        <GoodsSwiper
          list={list}
          id={`new-reserve-item-swiper`}
          options={{ showCategoryFilter: true }}
        />
      </div>
    </div>
  );
};

export default NewReserveGoodsSwiper;
